const createRouteString = (addresses: string[]) => {
  return addresses.join(" > ");
};

const mileageListingTableRouteFactory = {
  createRouteString,
};

export default mileageListingTableRouteFactory;
